import { render } from "./TransactionHistory.vue?vue&type=template&id=10aa7198&scoped=true"
import script from "./TransactionHistory.vue?vue&type=script&lang=js"
export * from "./TransactionHistory.vue?vue&type=script&lang=js"

import "./TransactionHistory.vue?vue&type=style&index=0&id=10aa7198&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10aa7198"]])

export default __exports__